<template>
    <div class="cst-survey-card-hc">
        <span v-html="introText"></span>
        <div class="cst-survey-card-hc-questions">
            <div :class="entryClass(entry)" :key="entry.name" v-for="entry in questionaire">
                  <h3>
                      <img v-if="entry.type==1" :src="categoryIcon(entry)" />
                      <span v-html="fieldHintText(entry)">
                      </span>
                  </h3>  
                  <span class="cst-survey-card-hc-field-desc" v-if="fieldDescriptionText(entry)" v-html="fieldDescriptionText(entry)"></span>
                  <div v-if="entry.type==1" @mouseleave="updateHoverSelection(entry,0)" class="cst-survey-hc-suns border-color-border">
                      <div @click="selectAnswerValue(entry,sunIndex)" v-bind:class="{ sun: 1, selected: sunIndex <= (entry.hovered ? entry.hovered : entry.value ) }" @mouseover="updateHoverSelection(entry,sunIndex)" :key="sunIndex" v-for="sunIndex in 6">
                      </div>    
                  </div>
                  <div v-if="entry.type==2" class="cst-survey-hc-title">
                      <input class="text-color" v-model="entry.value" type="text" />
                  </div>
                  <div v-if="entry.type==3" class="cst-survey-hc-text">
                      <textarea class="text-color" v-model="entry.value"></textarea>
                  </div>
                  <div v-if="entry.type==4" class="cst-survey-hc-thumbs">
                      <div v-bind:class="{ thumbs: 1, thumbsup: 1, selected: entry.value == 1 }" @click="selectAnswerValue(entry,1)"></div>
                      <div v-bind:class="{ thumbs: 1, thumbsdown: 1, selected: entry.value == 0 }" @click="selectAnswerValue(entry,0)"></div>
                  </div>
                  <div v-if="entry.type==5" class="cst-survey-hc-options">
                      <div @click="selectAnswerValue(entry,option.value)" v-bind:class="{ option: 1, selected: option.value == entry.value, 'border-color-border': 1 }" :key="option.value" v-for="option in shownOptions(entry.options)">
                       <img v-if="optionIcon(entry,option)" :src="optionIcon(entry,option)" />
                       {{  optionValueText(entry,option) }}
                      </div>    
                  </div>
                  <div v-if="hasRestrictions(entry)" :class="{'is-not-filled': !areRestrictionsFulfilled(entry), 'restriction-box': 1 }">
                        {{ entryLength(entry) }} / {{ getRestrictionsText(entry) }}
                  </div>
            </div>
        </div> 
        <div class="cst-survey-card-hc-privacy-consent">
          <label><input class="consent" v-model="gaveConsent" type="checkbox" />
            <div class="text">
              <span v-html="$t('hcConsentHint')" /><br /><span v-html="$t('hcPrivacyHint')"/>
            </div> 
          </label> 
        </div>
        <div class="hc-fill-status-hint" v-if="!isFullyFilled"> {{ $t('hcFilledHint')}} </div>
        <button @click="submitHolidayCheck()" class="cst-survey-hc-submit">{{ $t("btnSubmit") }}</button>

    </div>
</template>

<script>
    /* global eventHub, alert */
    /* eslint no-undef: "error" */
    import Vue from 'vue'
    import C from './../constants.js'
    export default {
      created: function () {
        eventHub.$emit('set-title', this.$t('hcCardTitle'))
        this.$store.dispatch('loadExternalSurvey', C.FOREIGN_SURVEY_TYPE_HOLIDAYCHECK).then(() => {
          this.initValues()
        })
      },
      data: function () {
        return {
          loaded: false,
          restrictions: {
            'title': [ { min: 2 }, { max: 50 } ],
            'text': [ { min: 100 } ],
            'firstName': [ { min: 1 }]
          },
          iconsEnabled: ['traveledWith', 'travelReason', 'ratingCostPerformance'],
          entryTypes: ['', 'suns', 'title', 'text', 'thumbs', 'options'],
          gaveConsent: false
        }
      },
      methods: {
        updateHoverSelection: function (entry, index) {
          Vue.set(entry, 'hovered', index)
        },
        selectAnswerValue: function (entry, value) {
          entry.value = value
        },
        submitHolidayCheck: function () {
          if (!this.isFullyFilled) {
            alert(this.$t('hcFilledHint'))
            return
          }

          var questionaire_data = this.$store.state.external_questionaires[1]
          this.$store.dispatch('submitExternalSurvey', { surveyType: C.FOREIGN_SURVEY_TYPE_HOLIDAYCHECK, answers: questionaire_data.questionaire, mappedValues: questionaire_data.mapped_values, hotel: questionaire_data.meta.hotelId }).then((a) => {
            this.$store.dispatch('gotoNamedCard', 'finished')
          })
        },
        hasRestrictions: function (entry) {
          return entry.field_name in this.restrictions
        },
        getRestrictions: function (entry) {
          if (entry.field_name in this.restrictions) {
            return this.restrictions[entry.field_name]
          }
          return []
        },
        entryClass: function (entry) {
          return 'cst-survey-card-hc-entry hc-entry-type-' + this.entryTypes[entry.type * 1]
        },
        entryLength: function (entry) {
          if (entry.type === '2') {
            return entry.value ? entry.value.length : 0
          }
          return entry.value ? entry.value.replace(/\s/g, '').length : 0
        },
        restrictionToText: function (restriction) {
          let restriction_text = []
          if ('min' in restriction) {
            restriction_text.push('min. ' + restriction.min)
          }
          if ('max' in restriction) {
            restriction_text.push('max. ' + restriction.max)
          }
          return restriction_text.join(' / ')
        },
        getRestrictionsText: function (entry) {
          return this.getRestrictions(entry).map(restriction => this.restrictionToText(restriction)).join(' / ')
        },
        areRestrictionsFulfilled (entry) {
          let restrictions = this.getRestrictions(entry)
          if (!restrictions.length) { return true }
          let res = restrictions.filter(restriction => !this.isRestrictionFulfilled(entry, restriction))
          return res.length === 0
        },
        isRestrictionFulfilled (entry, restriction) {
          if (('max' in restriction && this.entryLength(entry) > restriction.max) || ('min' in restriction && this.entryLength(entry) < restriction.min)) {
            return false
          }
          return true
        },
        fieldHintText (entry) {
          var fieldName = 'hcTitle_' + entry.field_name
          if (this.$te(fieldName)) {
            return this.$t(fieldName)
          }
          return entry.title
        },
        fieldDescriptionText (entry) {
          var fieldName = 'hcDescription_' + entry.field_name
          if (this.$te(fieldName)) {
            return this.$t(fieldName)
          }
          return false
        },
        optionValueText (entry, option) {
          var option_name = option.alias ? option.alias : option.value
          return this.$t('hcOption_' + entry.field_name + '_' + option_name)
        },
        optionIcon (entry, option) {
          if (this.iconsEnabled.indexOf(entry.field_name) !== -1) {
            var file_name = option.alias ? option.alias : option.value
            return `/static/hc/hc_${entry.field_name}_${file_name}.svg`
          }
          return false
        },
        categoryIcon (entry) {
          return `/static/hc/hc_category_${entry.field_name}.svg`
        },
        shownOptions: function (options) {
          return options.filter(option => !option.hidden)
        },
        initValues: function () {
          var mapped_values = this.$store.state.external_questionaires[C.FOREIGN_SURVEY_TYPE_HOLIDAYCHECK].mapped_values
          for (var entry_index in this.questionaire) {
            var entry = this.questionaire[entry_index]
            if (mapped_values[entry.field_name]) {
              entry.value = mapped_values[entry.field_name]
            }
          }
        }
      },
      computed: {
        questionaire: function () {
          try {
            return this.$store.state.external_questionaires[C.FOREIGN_SURVEY_TYPE_HOLIDAYCHECK].questionaire.filter(entry => entry.type !== '0')
          } catch (err) {
            return []
          }
        },
        isFullyFilled: function () {
          let missing_fields = this.questionaire.filter(entry => entry.value === null)
          let wrongly_filled_fields = this.questionaire.filter(entry => !this.areRestrictionsFulfilled(entry))
          return !missing_fields.length && !wrongly_filled_fields.length && this.gaveConsent
        },
        introText: function () {
          return this.$store.state.hotelData.text.hc_intro
        }
      }
    }
    </script>

<style lang="less" scoped>
    @import '../_theme';
    h2 {
        text-align: center;
        margin: 0;
        padding: 0;
    }
    .sun {
        width: 33px;
        height: 33px;
        display: inline-block;
        background-image: url('/static/hc-unfilled.png');
        background-repeat: no-repeat;
        background-position: center; 
        margin-right: 1em;
        background-size: cover;
    }
    
    .sun.selected {
        background-image: url('/static/hc-filled.png');
    }

    textarea {
        .textarea
    }
    input {
        .text-input
    }
    .thumbs {
        display: inline-block;
        box-sizing: border-box;
        width: 49.4%;
        height: 4em;
        border: 1px solid @border-color;
        background-repeat: no-repeat;
        background-position: center; 
    }
    .thumbsup {
        background-image: url('/static/thumbs_up.png');
    }
    .thumbsdown {
        background-image: url('/static/thumbs_down.png');
    }
    .thumbs:hover {
        border: 1px solid #AAA;
    }
    .thumbsup.selected {
        background-image: url('/static/thumbs_up_selected.png');
        background-color: #3FB14B;
    }
    .thumbsdown.selected {
        background-image: url('/static/thumbs_down_selected.png');
        background-color: #F13E33;
    }
    .cst-survey-hc-thumbs {
        display: flex;
        justify-content: space-between;        
    }    
    .cst-survey-hc-submit {
        .cst-survey-btn;
        margin: 0 auto;        
        display: block;
    }
    .cst-survey-hc-options {
        display: flex;
        justify-content: space-evenly;
        flex-flow: row wrap;
    }
    .cst-survey-hc-options .option * {
        display: flex;
    }

    .cst-survey-hc-options .option {
        border: 1px solid @border-color;
        flex-direction: column;
        //border: 1px solid;
        align-items: center; 
        display: flex;
        flex-grow: 1;
        margin: 0.3em;
        text-align: center;
        padding: 0.5em;
    }
    .cst-survey-hc-options .option:hover {
        background-color: #ccc;
    }
    .cst-survey-hc-options .option.selected {
        background-color: #FBE89D;
        //color: #fff;
    }
    .cst-survey-card-hc-entry {
        margin-bottom: 0.1em;
        overflow: auto;
    }
    .is-not-filled {
        color: red;
    }
    .restriction-box {
        // display: inline-block;
        float: right;
        font-size: 0.7em;
        
    }

    .hc-entry-type-suns {
        margin-bottom: 0.1em;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid @border-color;
    }
    .hc-entry-type-suns h3 {
        display: flex;
        align-items: center;
    }
    .hc-entry-type-suns h3 img {
        margin-right: 0.5em;
    }
    h3 {
        margin-left: 0.5em;
        text-align: center;
        margin-bottom: 0.5em;
    }
    .hc-entry-type-text h3, .hc-entry-type-title h3 {
        text-align: center;
    }
    input, textarea {
        box-sizing: border-box;
    }
    .cst-survey-card-hc-field-desc {
        font-size: 0.7em;
        text-align: center;
        display: block;
    }

    .cst-survey-card-hc-privacy-consent label {
      margin: 1em;
      display: block;
    }
    .cst-survey-card-hc-privacy-consent input {
      width: 1em;
      height: 1em;
      float: left;
      margin-right: 0.5em;
    }

    .hc-fill-status-hint {
      font-size: 0.8em;
      color: red;
      margin: 0.5em;
    }

    @media (max-width: 1350px) {
        .hc-entry-type-suns {
            flex-direction: column;
            padding-bottom: 1em;
        }

        .cst-survey-hc-options .option {
          padding: 1.2em;
        }
    }       

</style>




// WEBPACK FOOTER //
// src/components/CardHolidayCheck.vue